// Auto-extracted from packages/blockchain/artifacts — run `make gen-bindings` to refresh.
export const DID_REGISTRY_ABI = [
  { inputs: [], name: 'ECDSAInvalidSignature', type: 'error' },
  { inputs: [{ internalType: 'uint256', name: 'length', type: 'uint256' }], name: 'ECDSAInvalidSignatureLength', type: 'error' },
  { inputs: [{ internalType: 'bytes32', name: 's', type: 'bytes32' }], name: 'ECDSAInvalidSignatureS', type: 'error' },
  { inputs: [], name: 'ReentrancyGuardReentrantCall', type: 'error' },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'string', name: 'didHash', type: 'string' },
      { indexed: false, internalType: 'string', name: 'did', type: 'string' },
      { indexed: false, internalType: 'bytes32', name: 'name', type: 'bytes32' },
      { indexed: false, internalType: 'bytes', name: 'value', type: 'bytes' },
      { indexed: false, internalType: 'uint256', name: 'validTo', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'timestamp', type: 'uint256' },
    ],
    name: 'DIDAttributeChanged',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'string', name: 'didHash', type: 'string' },
      { indexed: false, internalType: 'string', name: 'did', type: 'string' },
      { indexed: true, internalType: 'address', name: 'owner', type: 'address' },
      { indexed: false, internalType: 'uint256', name: 'timestamp', type: 'uint256' },
    ],
    name: 'DIDCreated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'string', name: 'didHash', type: 'string' },
      { indexed: false, internalType: 'string', name: 'did', type: 'string' },
      { indexed: false, internalType: 'uint256', name: 'timestamp', type: 'uint256' },
    ],
    name: 'DIDDeactivated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'string', name: 'didHash', type: 'string' },
      { indexed: false, internalType: 'string', name: 'did', type: 'string' },
      { indexed: false, internalType: 'bytes32', name: 'delegateType', type: 'bytes32' },
      { indexed: false, internalType: 'address', name: 'delegate', type: 'address' },
      { indexed: false, internalType: 'uint256', name: 'validTo', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'timestamp', type: 'uint256' },
    ],
    name: 'DIDDelegateChanged',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'string', name: 'didHash', type: 'string' },
      { indexed: false, internalType: 'string', name: 'did', type: 'string' },
      { indexed: true, internalType: 'address', name: 'oldOwner', type: 'address' },
      { indexed: true, internalType: 'address', name: 'newOwner', type: 'address' },
      { indexed: false, internalType: 'uint256', name: 'timestamp', type: 'uint256' },
    ],
    name: 'DIDKeyRotated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'string', name: 'didHash', type: 'string' },
      { indexed: false, internalType: 'string', name: 'did', type: 'string' },
      { indexed: false, internalType: 'uint256', name: 'timestamp', type: 'uint256' },
    ],
    name: 'DIDUpdated',
    type: 'event',
  },
  {
    inputs: [
      { internalType: 'string', name: 'did', type: 'string' },
      { internalType: 'bytes32', name: 'delegateType', type: 'bytes32' },
      { internalType: 'address', name: 'delegate', type: 'address' },
      { internalType: 'uint256', name: 'validity', type: 'uint256' },
    ],
    name: 'addDelegate',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'string', name: 'did', type: 'string' },
      { internalType: 'bytes', name: 'didDocument', type: 'bytes' },
    ],
    name: 'createDID',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'string', name: 'did', type: 'string' }],
    name: 'deactivateDID',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'string', name: 'did', type: 'string' }],
    name: 'didExists',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'string', name: 'did', type: 'string' }],
    name: 'resolveDID',
    outputs: [
      { internalType: 'bytes', name: 'didDocument', type: 'bytes' },
      { internalType: 'address', name: 'owner', type: 'address' },
      { internalType: 'uint256', name: 'created', type: 'uint256' },
      { internalType: 'uint256', name: 'updated', type: 'uint256' },
      { internalType: 'bool', name: 'deactivated', type: 'bool' },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'string', name: 'did', type: 'string' },
      { internalType: 'bytes32', name: 'delegateType', type: 'bytes32' },
      { internalType: 'address', name: 'delegate', type: 'address' },
    ],
    name: 'revokeDelegate',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'string', name: 'did', type: 'string' },
      { internalType: 'address', name: 'newOwner', type: 'address' },
    ],
    name: 'rotateKey',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'string', name: 'did', type: 'string' },
      { internalType: 'bytes', name: 'newDocument', type: 'bytes' },
    ],
    name: 'updateDIDDocument',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
] as const;
